import { COLORS } from '@btime/constants'
import { compose, join, paths } from 'ramda'
import { usePageTitle } from '@btime/react-hooks'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { usePermalinkNavigation } from '../../../utils/routes/permalinkNavigation'
import { usePrintPdf } from '../../../components/pdf/options/_helpers/printPdf'
import IconText from '../../../components/presentation/IconText'
import Link from '../../../components/actions/Link'
import PageHeaderPanel from '../../../components/presentation/PageHeaderPanel'
import { useServiceOrder } from './_load/ServiceOrderLoader'

const PageHeader = () => {
  const serviceOrder = useServiceOrder()
  const { t } = useTranslation()
  const navigate = usePermalinkNavigation()
  const title = compose(join(' - '), paths([['yearlyId'], ['checklist', 'name']]))(serviceOrder)
  const [loading, print] = usePrintPdf(title)
  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/list`)}
      title={title}
      mediumPadding
      noContainer
      side={
        <Link onClick={print} block loading={loading} loadingColor={COLORS.white} loadingBgColor={COLORS.purple}>
          <IconText
            iconSize="1.4rem"
            weight="700"
            iconName="BsFileEarmarkBreak"
            color={COLORS.white}
            label={t('print')}
          />
        </Link>
      }
    />
  )
}

export default PageHeader
